module.exports = __webpack_public_path__ + "static/media/Metropolis-Regular.dda0bc1b.woff";